import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcRemove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 12.75a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 0 1.5z"
  }));
}
var IcRemove = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRemove));

export { IcRemove as I };
